import { Skeleton } from "@/components/ui/skeleton";
import { HERO_IMAGE } from "@/pages/hippo/constants";

export function InsightSkeleton() {
  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 backdrop-blur-sm bg-black/60" />
      </div>
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center p-4">
        <div className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl p-8 shadow-2xl">
          <Skeleton className="w-44 h-44 rounded-full bg-white/10 mx-auto mb-4" />
          <Skeleton className="h-6 w-48 mx-auto bg-white/10 mb-2" />
          <Skeleton className="h-4 w-32 mx-auto bg-white/10" />
        </div>
      </div>
    </div>
  );
}
